import { useState } from 'react'

import PageContainer from 'common/components/PageContainer'
import PageTitle from 'common/components/PageTitle'

import EmptyState from './components/EmptyState'
import SelectIntegrationOverlay from './components/SelectIntegrationOverlay'

const Integrations = () => {
  const [
    isSelectIntegrationOverlayVisible,
    setIsSelectIntegrationOverlayVisible,
  ] = useState(false)

  return (
    <PageContainer className="max-w-318 sm:mx-auto pt-10">
      <PageTitle title="Integrations" />
      <div className="text-coolGray-400 mt-2">
        Make the most of Phrasee integrations and do even more.
      </div>
      <EmptyState
        onAddClick={() => setIsSelectIntegrationOverlayVisible(true)}
      />
      <SelectIntegrationOverlay
        isOpen={isSelectIntegrationOverlayVisible}
        onClose={() => setIsSelectIntegrationOverlayVisible(false)}
      />
    </PageContainer>
  )
}

export default Integrations
